import * as React from 'react'

import { useFieldHover } from '../../hooks/useFieldHover'
import { cn } from '../../utils/cn'

export function Textarea({
  className,
  onPointerEnter,
  onPointerLeave,
  ...props
}: React.ComponentProps<'textarea'>) {
  const hoverProps = useFieldHover(onPointerEnter, onPointerLeave)

  return (
    <textarea
      data-slot="textarea"
      {...hoverProps}
      className={cn(
        'border-input placeholder:text-ink-300 enabled:hover:data-hovered:not-focus-visible:border-ink-300 focus-visible:border-ring aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 text-md bg-surface flex field-sizing-content min-h-16 w-full resize-none rounded-md border px-3 py-2 shadow-xs transition-[color,box-shadow] outline-none hover:outline-none disabled:cursor-not-allowed disabled:opacity-50 hover:data-hovered:shadow-none md:pointer-fine:text-sm',
        className
      )}
      {...props}
    />
  )
}
